import { zetApi } from '@zet/network'

import { IdemoLeadData } from './types'

export async function getDemoLeadDetails() {
  const { data } = await zetApi.get<IdemoLeadData>(
    'v1/demo/customers-lead/details'
  )
  return data?.data
}

export async function setDemoLeadStatus({ status }: { status: string }) {
  const { data } = await zetApi.put(
    `v1/demo/lead/status/update?status=${status}`
  )
  return data?.data
}
